module.exports = __webpack_public_path__ + "assets/ic_camera.f33dd582.svg";